import React, { useEffect, useState } from 'react';
import { Container, Button, Box, Stack, Typography, Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getAllBrands } from '../../server/api/vehicle';
import { useDevice } from '../../hooks/useResponsive';
import { MetaHelmet } from '../../layouts/Helmet/Helmet';

export default function InspectionBookingPage() {
  const { isMobile } = useDevice();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { brands, loading } = useSelector((state) => ({
    brands: state.vehicle.brands?.response,
    loading: state.vehicle.loading,
  }));

  const [selectedBrandId, setSelectedBrandId] = useState(null);

  useEffect(() => {
    const credentials = {
      dispatch,
      page: 1,
      limit: 30,
      searchText: '',
    };
    dispatch(getAllBrands(credentials));
  }, [dispatch]);

  const handleSelect = (brand) => {
    setSelectedBrandId(brand);
  };
  console.log('selectedBrandId>>>>>>>>>>>>', selectedBrandId);
  return (
    <>
      <MetaHelmet title={'Dream Car Booking'} companyName={'Focus Motors'} />
      {/* <SubmitModal open={modal} close={() => setModal(false)} /> */}
      <Box className="bg-light ">
        <Container
          maxWidth="xl"
          sx={{
            padding: isMobile ? 'unset' : '0px 0px 500px 0px !important',
            position: 'relative',
            minHeight: !isMobile && '100vh',
            backgroundColor: '#f0f1f3',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: isMobile ? 150 : 500,
              backgroundImage: 'url(/assets/images/Inspection/VerifyBanner.webp)',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          />
          <Container
            maxWidth="md"
            sx={{
              position: 'absolute',
              top: isMobile ? 0 : '15%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderRadius: isMobile ? 0 : '24px',
              backgroundColor: '#FFFFFF',
            }}
          >
            <Typography fontSize="32px" fontWeight="500" my={4} color="#1C252E" textAlign="center">
              Inspection Booking
            </Typography>
            <Box
              sx={{
                maxWidth: '500px',
                margin: 'auto',
                bgcolor: '#fff',
                borderRadius: '24px',
                overflow: 'hidden',
                // boxShadow: 3,
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  textAlign: 'center',
                  py: 2,
                  borderRadius: '24px',
                  border: '1px solid #33333333',
                  position: 'relative',
                  mt: 2,
                  pt: 2,
                  borderBottomColor: 'transparent',
                  borderRight: 'unset',
                  borderLeft: 'unset',
                }}
              >
                <Typography
                  width="fit-content"
                  fontWeight={500}
                  backgroundColor="white"
                  position="absolute"
                  fontSize="16px"
                  sx={{ left: '50%', px: 1, transform: 'translateX(-50%)', top: '-12px', zIndex: 2 }}
                >
                  Select Vehicle Brand
                </Typography>
              </Box>

              {/* List */}
              <Stack
                sx={{
                  maxHeight: '395px', // controls ~7.5 items
                  overflowY: 'auto',
                  mt: -3,
                  backgroundColor: 'white',
                  pt: 3,
                  // px: 2,
                }}
              >
                {loading ? (
                  <Stack spacing={2} sx={{ maxHeight: 400, overflowY: 'auto', p: 1 }}>
                    {[...Array(7)].map((_, index) => (
                      <Stack
                        key={index}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          border: '1px solid #eee',
                          borderRadius: '12px',
                          p: 1.5,
                          mb: 1,
                        }}
                      >
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Skeleton variant="circular" width={32} height={32} />
                          <Skeleton variant="text" width={100} height={20} />
                        </Stack>
                        <Skeleton variant="circular" width={20} height={20} />
                      </Stack>
                    ))}
                  </Stack>
                ) : (
                  brands?.brands?.map((brand) => {
                    const isSelected = selectedBrandId?._id === brand._id;

                    return (
                      <Stack
                        key={brand.id}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        onClick={() => handleSelect(brand)}
                        sx={{
                          border: isSelected ? '1px solid #FF9800' : 'unset',
                          borderRadius: '26px',
                          backgroundColor: isSelected && '#fffdfc',
                          p: 1.5,
                          px: isMobile ? 2 : 3,
                          // mb: 1,
                          cursor: 'pointer',
                          '&:hover': { bgcolor: '#fafafa' },
                        }}
                      >
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Box
                            component="img"
                            src={brand?.logo?.[0]?.url}
                            alt={brand?.name}
                            sx={{ width: 25, height: 25, objectFit: 'contain' }}
                          />
                          <Typography variant="body1" color="#333333DE" fontWeight={500}>
                            {brand?.name}
                          </Typography>
                        </Stack>
                        {
                          isSelected && (
                            <Box
                              component="img"
                              src="assets/images/Inspection/CheckCircle.png"
                              alt="tick"
                              sx={{ width: 24, height: 24, objectFit: 'contain' }}
                            />
                          )
                          // <CheckCircleOutlineIcon sx={{ color: '#FF9800', fontSize: '24px' }} />
                        }
                      </Stack>
                    );
                  })
                )}
              </Stack>

              {/* Footer buttons */}
              <Stack sx={{ pt: 4, pb: isMobile ? 10 : 7 }} spacing={isMobile ? 3 : 6}>
                <Button
                  fullWidth
                  variant="contained"
                  disabled={selectedBrandId === null || selectedBrandId === undefined}
                  sx={{
                    borderRadius: '50px',
                    boxShadow: 'unset',
                    background: 'linear-gradient(90deg, #FF9910 0%, #F16400 100%)',
                    textTransform: 'none',
                    fontWeight: 600,
                    py: 1,
                    color: 'white',
                    '&.Mui-disabled': {
                      background: 'linear-gradient(90deg, #e0e0e0 0%, #f5f5f5 100%)',
                      color: 'white',
                      opacity: 1, // keep text visible (MUI defaults to lower opacity)
                    },
                  }}
                  onClick={() => {
                    navigate('/booking', { state: { selectedBrandId } });
                  }}
                >
                  <Typography color="white">Next</Typography>
                </Button>
                {/* <Typography variant="body2" sx={{ color: '#1565C0', textAlign: 'center', cursor: 'pointer' }}>
                  View Inspection Report
                </Typography> */}
              </Stack>
            </Box>
          </Container>
        </Container>
      </Box>
    </>
  );
}
